import React, { useEffect, useState } from "react";

import NewOrderStoreCard from "./NewOrderStoreCard";
import StoreOwnerOrderSummary from "./StoreOwnerOrderSummary";
import { useOutletContext } from "react-router-dom";

const StoreOwnerOrder = () => {
  const {
    orderModel,
    setOrderModel,
    setCustomerStoreOwnerData,
    customerStoreOwnerData,
    setStoreOwnerCart,
    storeOwnerCart,
  } = useOutletContext();

  return (
    <>
      {orderModel ? (
        <>
          <StoreOwnerOrderSummary
            setOrderModel={setOrderModel}
            cart={storeOwnerCart}
            setCart={setStoreOwnerCart}
            customerData={customerStoreOwnerData}
            setCustomerData={setCustomerStoreOwnerData}
          />
        </>
      ) : (
        <>
          <NewOrderStoreCard
            cart={storeOwnerCart}
            setCart={setStoreOwnerCart}
            customerData={customerStoreOwnerData}
            setCustomerData={setCustomerStoreOwnerData}
            setOrderModel={setOrderModel}
          />
        </>
      )}
    </>
  );
};

export default StoreOwnerOrder;
